module.exports = __webpack_public_path__ + "img/40_38_081_770.3edc30e9.jpg";